module.exports = __webpack_public_path__ + "static/media/S2N13-2.7d585c56.svg";